<template>
  <div class="main-content-container overflow-hidden">
    <PageTitle pageTitle="Form Ship Owner Company" subTitle="Forms" />

    <CreateShipOwnerCompany />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/Common/PageTitle.vue";
import CreateShipOwnerCompany from "@/components/Pages/Master/ShipOwnerCompany/CreateShipOwnerCompany.vue";

export default defineComponent({
  name: "CreateShipOwnerCompanyPage",
  components: {
    PageTitle,
    CreateShipOwnerCompany,
  },
});
</script>
